import axios from "axios";

const configAxios = axios.create({
  baseURL: process.env.REACT_APP_API_ESTAGE,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default configAxios;
